var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ModalForm", {
    attrs: {
      id: "add-secret-modal",
      title: "Add Secret",
      submitButtonText: "Generate Secret",
      onSubmit: _vm.generateSecret,
    },
    on: { success: _vm.onSuccess, hidden: _vm.onHide },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var disabled = ref.disabled
          return [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var classes = ref.classes
                      var errors = ref.errors
                      var touched = ref.touched
                      return [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "newSecretName" } }, [
                            _vm._v("Name"),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSecretName,
                                expression: "newSecretName",
                              },
                            ],
                            staticClass: "form-control",
                            class: classes,
                            attrs: {
                              id: "newSecretName",
                              type: "text",
                              placeholder: "Default",
                              disabled: disabled,
                            },
                            domProps: { value: _vm.newSecretName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.newSecretName = $event.target.value
                              },
                            },
                          }),
                          touched
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(_vm._s(errors[0])),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }